import { Content } from 'shared/components/Content';
import { SolveProblemsContainer } from '../SolveProblemsContainer';
import { ProtectYouContainer } from '../ProtectYouContainer';
import { AboutServiceBannerContainer } from '../AboutServiceBannerContainer';
import { HeaderContainer } from '../HeaderContainer';
import { ModalFormContainer } from '../ModalFormContainer';
import { useSelector } from 'react-redux';
import { getModalVisible } from 'shared/selectors/modal';
import { useAppDispatch } from 'shared/hooks';
import { setModalVisible } from 'shared/slices';
import { useCallback } from 'react';
import { ReviewsContainer } from '../ReviewsContainer';

export const ContentContainer: React.FC = () => {
  const modalVisible = useSelector(getModalVisible);

  const dispatch = useAppDispatch();

  const handleModalVisible = useCallback(() => {
    dispatch(setModalVisible(!modalVisible));
  }, [dispatch, modalVisible]);

  return (
    <Content
      onChangeVisibleModal={handleModalVisible}
      header={<HeaderContainer onChangeModalVisible={handleModalVisible} />}
      solveProblems={<SolveProblemsContainer />}
      protectYou={<ProtectYouContainer />}
      aboutService={<AboutServiceBannerContainer />}
      reviews={<ReviewsContainer />}
      modal={<ModalFormContainer onClose={handleModalVisible} />}
    />
  );
};
